export default "__VITE_ASSET__BtumrlN1__"